"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _withIcon = _interopRequireDefault(require("./withIcon"));
const OverflowPrizm = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "32px",
  height: "32px",
  viewBox: "0 0 32 32"
}, props), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("g", {
  transform: "translate(13.000000, 6.000000)"
}, _react.default.createElement("path", {
  d: "M3,14 C4.65685425,14 6,15.3431458 6,17 C6,18.6568542 4.65685425,20 3,20 C1.34314575,20 0,18.6568542 0,17 C0,15.3431458 1.34314575,14 3,14 Z M3,7 C4.65685425,7 6,8.34314575 6,10 C6,11.6568542 4.65685425,13 3,13 C1.34314575,13 0,11.6568542 0,10 C0,8.34314575 1.34314575,7 3,7 Z M3,0 C4.65685425,0 6,1.34314575 6,3 C6,4.65685425 4.65685425,6 3,6 C1.34314575,6 0,4.65685425 0,3 C0,1.34314575 1.34314575,0 3,0 Z M3,18 C2.4,18 2,17.6 2,17 C2,16.4 2.5,16 3,16 C3.5,16 4,16.4 4,17 C4,17.6 3.6,18 3,18 L3,18 Z M3,2 C3.6,2 4,2.4 4,3 C4,3.6 3.5,4 3,4 C2.4,4 2,3.6 2,3 C2,2.4 2.5,2 3,2 L3,2 Z M3,11 C2.4,11 2,10.6 2,10 C2,9.4 2.5,9 3,9 C3.5,9 4,9.4 4,10 C4,10.6 3.5,11 3,11 L3,11 Z"
}))));
const OverflowMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("path", {
  d: "M12,9.5 C13.3807119,9.5 14.5,10.6192881 14.5,12 C14.5,13.3807119 13.3807119,14.5 12,14.5 C10.6192881,14.5 9.5,13.3807119 9.5,12 C9.5,10.6192881 10.6192881,9.5 12,9.5 Z M3,9.5 C4.38071187,9.5 5.5,10.6192881 5.5,12 C5.5,13.3807119 4.38071187,14.5 3,14.5 C1.61928813,14.5 0.5,13.3807119 0.5,12 C0.5,10.6192881 1.61928813,9.5 3,9.5 Z M21,9.5 C22.3807119,9.5 23.5,10.6192881 23.5,12 C23.5,13.3807119 22.3807119,14.5 21,14.5 C19.6192881,14.5 18.5,13.3807119 18.5,12 C18.5,10.6192881 19.6192881,9.5 21,9.5 Z M12,10.5 C11.1715729,10.5 10.5,11.1715729 10.5,12 C10.5,12.8284271 11.1715729,13.5 12,13.5 C12.8284271,13.5 13.5,12.8284271 13.5,12 C13.5,11.1715729 12.8284271,10.5 12,10.5 Z M3,10.5 C2.17157288,10.5 1.5,11.1715729 1.5,12 C1.5,12.8284271 2.17157288,13.5 3,13.5 C3.82842712,13.5 4.5,12.8284271 4.5,12 C4.5,11.1715729 3.82842712,10.5 3,10.5 Z M21,10.5 C20.1715729,10.5 19.5,11.1715729 19.5,12 C19.5,12.8284271 20.1715729,13.5 21,13.5 C21.8284271,13.5 22.5,12.8284271 22.5,12 C22.5,11.1715729 21.8284271,10.5 21,10.5 Z"
})));
const AbstractOverflow = ({
  theme,
  ...other
}) => theme.name === 'mds' ? _react.default.createElement(OverflowMDS, other) : _react.default.createElement(OverflowPrizm, other);
var _default = exports.default = (0, _styledComponents.withTheme)((0, _withIcon.default)('Overflow')(AbstractOverflow));